import { z } from "zod";
import { LongText, MediumText, idString } from "./common.js";
/**
 * SIPOC (Suppliers · Inputs · Process · Outputs · Customers) — the VSM scoping
 * board. Each row describes one Process step plus its four multi-entry lists.
 * A row may carry `linkedEntityId` tying it to a current-state map node; the
 * link target itself is wired later (PB-197). Rendered data-blind by the DS
 * `SipocWidget`.
 */
const SipocEntry = z
    .object({
    id: idString,
    text: MediumText,
    /** Optional id of the map shape or flow created from this entry. */
    linkedEntityId: idString.optional(),
})
    .strict();
export const SipocPartyClassificationSchema = z.enum(["internal", "external"]);
const SipocPartyEntry = SipocEntry.extend({
    classification: SipocPartyClassificationSchema.optional(),
}).strict();
const SipocFlowEntry = SipocEntry.extend({
    requirements: LongText.optional(),
    notes: LongText.optional(),
}).strict();
/** Details belong to inputs/outputs; party classification belongs to S/C. */
const EntryList = z.array(SipocFlowEntry).max(50);
const PartyEntryList = z.array(SipocPartyEntry).max(50);
const SipocRow = z
    .object({
    id: idString,
    process: MediumText,
    /** Optional id of the linked current-state process node (PB-197). */
    linkedEntityId: idString.optional(),
    suppliers: PartyEntryList,
    inputs: EntryList,
    outputs: EntryList,
    customers: PartyEntryList,
})
    .strict();
export const SipocParamsSchema = z
    .object({
    rows: z.array(SipocRow).max(50),
})
    .strict();
export const defaultSipocParams = {
    rows: [],
};
//# sourceMappingURL=sipoc.js.map